import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import SumaContexto  from '../../contexto/SumaContexto';
import Contrasena from '../crear-cuenta/Contrasena'
import queryString from 'query-string';
import ServicioUsuarios from '../../servicios/usuarios/ServicioUsuarios'
import { Spin, message, Alert, Modal } from 'antd';
import Constantes from '../../utilidades/Constantes'


function ValidarActivarUsuario( attr ){
    //console.log('attr',attr);
    //let urlparametros = queryString.parse( attr.urlparametros );
    //console.log('urlparametros',urlparametros);

    if( attr.cargando ){
        return (
            <>
                <div className="titulo-seccion">
                    <label>ACTIVAR USUARIO MIGRACIÓN</label>
                    <div className="separador-horizontal-completo"></div>
                </div>
                <div className="cargando-pagina">
                    <Spin tip="Por favor espera..." size="large" ></Spin>
                </div>
            </>
        )
    }

    if( !attr.activarCuenta ){
        return( 
            <>
                <div>
                    <Alert message={'PETICIÓN NO DISPONIBLE. ' + attr.msgError} type="warning" />
                </div>
            </>
        );
    }else{

        return( 
            <>
                <div className="titulo-seccion">
                    <label>ACTIVAR USUARIO MIGRACIÓN</label>
                    <div className="separador-horizontal-completo"></div>
                    <p className="descripcion-seccion">Para activar tu usuario debes asignar una nueva contraseña con la cual podrás ingresar al portal. </p>
                    
                    Debe ser mínimo de 8 caracteres y tener al menos:
                    <ul>
                        <li>Una letra mayúscula</li>
                        <li>Una letra minúscula</li>
                        <li>Un dígito</li>
                        <li>Alguno de los siguientes caracteres: ! @ # $ % ^ & *</li>
                    </ul>
                    
                    <br/>
                </div>
                <div className="seccion-formulario">
                    <Contrasena usuarioInformacionBasicaDto={attr.usuarioInformacionBasicaDto} token={attr.token}
                                callbackSatisfactorioContrasena={()=>{
                                    Modal.success({
                                        content:'Tu usuario ha sido activado, ahora puedes ingresar al portal SUMA+ con tu correo electrónico y la contraseña que registraste', 
                                        onOk:() =>{ 
                                            if( attr.contexto._isMounted ){
                                                attr.contexto.historyLocal.push('/');
                                            }
                                         }
                                    });
                                }}/>
                </div>
            </>
        );
    }
}

class ActivarUsuarioMigracion extends Component {

    static contextType = SumaContexto;

    state = {
        cargando:true,
        activarCuenta:false,
        msgError:null,
    };

    constructor(props){
        super(props);
        this.historyLocal = props.history;
        this.servicioUsuarios = new ServicioUsuarios( props );
    }

    componentDidMount() {
        this._isMounted = true;
        let params = this.props.location.search;
        let urlparametros = queryString.parse( params );
        this.enc = null;
        if(urlparametros.enc !== undefined){
            this.enc = urlparametros.enc;
            this.servicioUsuarios.usuarioMigracion(
                this.enc,
                ( respuestaApi )      => { 
                    let msgError = respuestaApi.mensaje;
                    switch(respuestaApi.codigo){
                        case Constantes.ENUMS_API.USUARIO.USUARIO_MIGRACION.id:
                            this.setSumaState({ 
                                usuarioInformacionBasicaDto: respuestaApi.resultado , 
                                cargando:false, 
                                activarCuenta: true,
                                msgError:null });
                            break;    
                        default:
                            this.setSumaState({ 
                                cargando:false, 
                                activarCuenta: false,
                                msgError: msgError
                            });
                            break;
                    }
                },
                ( errorAPI )    => { message.error('Error de conexión. Por favor intenta mas tarde.', 10 ) },
            );
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

  render() {
    
    let contexto = this;

    return (
        <div className="seccion-principal seccion-flex">
          <div className="division-principal">
            <label>Activar Usuario Migración</label>
          </div>
          <div className="division-contenido seccion-flex-grow-1 padding-principal bkg-white">
                <ValidarActivarUsuario  cargando={this.state.cargando} 
                                        activarCuenta={this.state.activarCuenta}  
                                        usuarioInformacionBasicaDto={this.state.usuarioInformacionBasicaDto}
                                        msgError={this.state.msgError}
                                        token={this.enc}
                                        contexto={ contexto }/>
            </div>
        </div>
      );
  }
}

export default withRouter(ActivarUsuarioMigracion);